// Autrona Acoustic Computer Kernel Module: Keyboard
// Handle all key strokes, keep track of modifiers, 
// then pass the events to the currently running program,
// including main for control-sequences

// Configuration
const modifiers = ['Control'];
const defaultPrevented = [' ', 'ArrowUp', 'ArrowDown'];

// Variables
const activeModifiers = [];

// Initialize module
function init() {
    document.addEventListener('keydown', handleKeyDowns);
    document.addEventListener('keyup', handleKeyUps);
}

// General keydown event callback
function handleKeyDowns(e) {
    //console.log('Keystroke:', e.key)
    if (modifiers.includes(e.key)) {
        addModifier(e.key);
    }
    if (defaultPrevented.includes(e.key)) e.preventDefault();
}

// keyup event callback
function handleKeyUps(e) {
    if (modifiers.includes(e.key)) {
        removeModifier(e.key);
    }
}

// Modifier keys handling
function addModifier(key) {
    activeModifiers.push(key);
}

function removeModifier(key) {
    const modifierIndex = activeModifiers.indexOf(key);
    activeModifiers.splice(modifierIndex, 1);
}

export { init, activeModifiers }
